module.exports = __webpack_public_path__ + "static/media/smartphoneUport.7a7eb597.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smartphoneUport.png
// module id = 761
// module chunks = 1 3